module.exports = __webpack_public_path__ + "img/p6-p1-yu3.226dde13.png";